import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import weather from "../../Assets/Projects/weather.webp";
import netflix from "../../Assets/Projects/netflix.webp";
import currency from "../../Assets/Projects/currency.webp";
import rps from "../../Assets/Projects/rps.webp";
import mza from "../../Assets/Projects/mza.webp";
import resume from "../../Assets/Projects/resume.webp";   
import n8n from "../../Assets/Projects/workflow.webp";         

const projects = [
  {
    imgPath: mza,
    title: "MZA Consultancy Compliance Website",
    description:
      "A professional compliance consultancy website built to showcase services, handle client inquiries, and improve online presence with a clean and responsive UI.",
    demoLink: "https://mycompliances.com/",
  },
  {
    imgPath: n8n,
    title: "Workflow Automation using N8N and Apify",
    description:
      "Designed and implemented N8N and Apify automation workflows to orchestrate web scraping, API integration, and data processing, enabling real-time data collection and automated downstream actions.",
    ghLink: "https://github.com/MohammadAvaan/Apify-N8N-Automation-Pipeline",
  },
  {
    imgPath: resume,
    title: "Resume Builder Web Application",
    description:
      "A dynamic resume builder that allows users to create, customize, and download professional resumes with real-time preview and responsive design.",
    ghLink: "https://github.com/MohammadAvaan/Resume-Builder-Mern", 
    demoLink: "https://resume-builder-mern-alpha.vercel.app/",        
  },
  {
    imgPath: weather,
    title: "Weather Prediction Tool",
    description:
      "A real-time weather forecasting application using API integration to display temperature, humidity, and weather conditions based on user location or search.",
    ghLink: "https://github.com/MohammadAvaan/Weather-Prediction-Tool.git",
  },
  {
    imgPath: netflix,
    title: "Netflix Clone",
    description:
      "A Netflix UI clone built using React featuring movie listings, banners, and categories powered by an external movie database API.",
    ghLink: "https://github.com/MohammadAvaan/Netflix-clone.git",
    demoLink: "https://mohammadavaan.github.io/Netflix-clone/",
  },
  {
    imgPath: currency,
    title: "Currency Converter",
    description:
      "A currency converter application that fetches live exchange rates and instantly converts between multiple international currencies.",
    ghLink: "https://github.com/MohammadAvaan/Currency-Converter.git",
    demoLink: "https://mohammadavaan.github.io/Currency-Converter/",
  },
  {
    imgPath: rps,
    title: "Rock Paper Scissors Game",
    description:
      "An interactive Rock Paper Scissors game built with JavaScript featuring score tracking and a responsive user interface.",
    ghLink: "https://github.com/MohammadAvaan/Rock-Paper-Scissors-Game.git",
    demoLink: "https://mohammadavaan.github.io/Rock-Paper-Scissors-Game/",
  },
];

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />

      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Projects</strong>
        </h1>

        <p style={{ color: "white" }}>
          A selection of projects showcasing my skills in automation, web development, and problem-solving.
        </p>

        <Row className="justify-content-center">
          {projects.map((project, index) => (
            <Col key={index} lg={4} md={6} sm={12} className="project-card">
              <ProjectCard {...project} />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
